import type { ReactNode } from 'react';

/** A labelled value in a read view: a small eyebrow over the value. */
export default function Fact({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div style={{ minWidth: 0 }}>
      <div
        style={{
          fontSize: 9.5,
          fontWeight: 700,
          letterSpacing: '.06em',
          textTransform: 'uppercase',
          color: 'var(--nb-subtle)',
          marginBottom: 3,
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: 13, color: 'var(--nb-ink)', wordBreak: 'break-word' }}>
        {children}
      </div>
    </div>
  );
}
